import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['bar', 'allButton', 'topicButton', 'scrollLeft', 'scrollRight'];

  static values = {
    scrollPosition: {
      type: String,
      default: 'left',
    },
  };

  connect() {
    // Select all button if present and nothing else is selected.
    const anyActive = this.topicButtonTargets.some((button) => button.dataset.active);
    if (!anyActive && this.allButtonTarget) {
      this.selectButton(this.allButtonTarget);
    }

    // Scroll to first active button
    const firstActiveButton = this.topicButtonTargets.find((button) => button.dataset.active);
    if (firstActiveButton) {
      this.barTarget.scrollTo({
        left: firstActiveButton.offsetLeft - firstActiveButton.offsetWidth,
      });
    }

    if (this.scrolledToTheRight() && this.scrollBarNeeded()) {
      this.scrollLeftTarget.hidden = false;
    }

    if (this.scrolledToTheLeft() && this.scrollBarNeeded()) {
      this.scrollRightTarget.hidden = false;
    }
  }

  select(event) {
    this.unselectAll();

    const button = event.target;
    this.selectButton(button);

    if (button.dataset.turboStream && button.dataset.turboAction === 'advance') {
      this.pushTurboStreamToHistory(event);
    }
  }

  pushTurboStreamToHistory = (event) => {
    const url = event.target.href;
    window.history.pushState({}, '', url.toString());
  };

  selectButton = (button) => {
    button.setAttribute('aria-current', 'page');
    button.setAttribute('data-active', true);
  };

  unselectButton = (button) => {
    button.removeAttribute('aria-current');
    button.removeAttribute('data-active');
  };

  unselectAll = () => {
    this.topicButtonTargets.forEach((button) => {
      if (button.dataset.active) {
        this.unselectButton(button);
      }
    });
  };

  scrollPositionValueChanged = () => {
    if (this.scrollPositionValue === 'right') {
      this.scrollRightTarget.hidden = true;
    } else if (this.scrollPositionValue === 'left') {
      this.scrollLeftTarget.hidden = true;
    } else {
      this.scrollRightTarget.hidden = false;
      this.scrollLeftTarget.hidden = false;
    }
  };

  scrollRight = () => {
    this.scroll((a, b) => a + b);
  };

  scrollLeft = () => {
    this.scroll((a, b) => a - b);
  };

  scroll = (leftOrRight) => this.barTarget.scrollTo({
    left: leftOrRight(this.barTarget.scrollLeft, this.barTarget.offsetWidth / 2),
    behavior: 'smooth',
  });

  watchScrollPosition = () => {
    if (this.scrolledToTheRight()) {
      this.scrollPositionValue = 'right';
    } else if (this.scrolledToTheLeft()) {
      this.scrollPositionValue = 'left';
    } else {
      this.scrollPositionValue = 'middle';
    }
  };

  scrolledToTheRight = () => this.barTarget.scrollLeft >= this.scrollEnd() - 1
    && this.barTarget.scrollLeft <= this.scrollEnd() + 1;

  scrolledToTheLeft = () => this.barTarget.scrollLeft === 0;

  scrollBarNeeded = () => this.barTarget.scrollWidth > this.barTarget.offsetWidth;

  scrollEnd = () => this.barTarget.scrollWidth - this.barTarget.offsetWidth;
}
